module.exports = __webpack_public_path__ + "static/img/son6.aab1d865.png";